import { Icon } from '@cmg/common';
import React from 'react';
import type { DefaultTheme } from 'styled-components';
import styled, { ThemeConsumer } from 'styled-components';

const SStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;
`;

const SIconWrapper = styled.div`
  margin-right: 5px;
  display: flex;
  align-self: center;
`;

export type Props = {
  activeLabel?: string;
  inactiveLabel?: string;
  isActive: boolean;
  inactiveIsNeutral?: boolean;
};

type StatusState = 'ACTIVE' | 'INACTIVE' | 'NEUTRAL_INACTIVE';

const resolveStatusState = (isActive: boolean, inactiveIsNeutral?: boolean): StatusState => {
  if (isActive) {
    return 'ACTIVE';
  }

  return inactiveIsNeutral ? 'NEUTRAL_INACTIVE' : 'INACTIVE';
};

const getColor = (theme: DefaultTheme, state: StatusState) => {
  if (state === 'ACTIVE') {
    return theme.brand.color.success;
  }

  if (state === 'NEUTRAL_INACTIVE') {
    return theme.brand.color.dark;
  }

  return theme.brand.color.danger;
};

const Status: React.FC<Props> = ({
  activeLabel = 'Active',
  inactiveLabel = 'Inactive',
  isActive,
  inactiveIsNeutral,
}) => (
  <SStatus>
    <SIconWrapper>
      <ThemeConsumer>
        {theme => {
          const state = resolveStatusState(isActive, inactiveIsNeutral);

          return (
            <Icon
              fixedWidth
              name="circle"
              variant="solid"
              size="xs"
              color={getColor(theme, state)}
            />
          );
        }}
      </ThemeConsumer>
    </SIconWrapper>
    <div>{isActive ? activeLabel : inactiveLabel}</div>
  </SStatus>
);

export default Status;
